import createReducer from '../createReducer';
import {TAiAgent} from './aiAgent.type';

const initialState: TAiAgent = {
    isOpen: false,
    meta: null,
    metaPid: null,
    metaXHR: null,
    sessionDiscriminator: null,
    sessionIntent: null,
    chatLang: null,
    pendingTicketTid: null,
    currentFormValues: null,
    pendingProposal: null,
    pendingProposalOwner: null,
    createdDraftFields: null,
    createdDraftEid: null,
    activeFormId: null,
    pendingFeedback: null,
    sendMessageXHR: null,
    executeProposalXHR: null,
    feedbackXHR: null,
};

export default createReducer('aiAgent', initialState);
